<div class="flex flex-row">
    <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
  </div>

  <div class="flex flex-row justify-between items-center pl-24 pr-24 pb-8 pt-32">
    <div class="mat-headline-5 m-0">{{'LEFT_SIDE_NAV.VIEW_REQUEST' | transloco }} <br> 
    <span class="fw-400 fs-12">{{'LEFT_SIDE_NAV.INITIAL_SYSTEM_BUILDS' | transloco }}</span>
    </div>
    <div class="mat-headline-5 m-0 fw-400"></div>
    <div class="flex flex-row justify-center items-center">
      <div>
        <button class="flex justify-center items-center context-menu-icon pl-6 pr-16">
          <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
          <span class="mat-body-1 fw-500">{{'SOLUTIONS.FILTERS' | transloco }}</span>
        </button>
      </div>
      <div>
        <button type="button" class="flex justify-center items-center tenant-gradient mat-subtitle-2 fw-700 m-0 pl-16 pr-16" 
         (click)="addNewPackage()"  mat-button>
          <mat-icon svgIcon="add" class="icon-md-2 pr-4"></mat-icon>
          {{'ISB.CREATE_PACKAGE' | transloco }}
        </button>
      </div>
    </div>
  </div>

  <div class="flex flex-row justify-center items-center">
    <h1 class="pt-200">{{'TENANT_DETAILS.COMING_SOON' | transloco}}</h1>
  </div>
  

